/* El billete (切符) con su sello: la cara de cada reserva. */
import type { Reserva, Viaje } from '../datos/tipos.ts';
import { euros, fechaCorta, num2, titulo } from '../texto.ts';

export type EstadoReserva = 'ok' | 'pendiente' | 'destino' | 'cancelado';
export const estadoRes = (r: Reserva): EstadoReserva => {
  const e = r.estado ?? '';
  return /CANCEL/.test(e) ? 'cancelado' : /PENDIENTE/.test(e) ? 'pendiente' : /FLEXIBLE|EN DESTINO|OPCIONAL/.test(e) ? 'destino' : 'ok';
};
export const SELLO: Record<EstadoReserva, string> = { ok: '済', pendiente: '未', destino: '現', cancelado: '消' };
export const tieneLoc = (r: Reserva) => !!r.localizador && r.localizador !== '—';

export function CaraKippu({ v, r }: { v: Viaje; r: Reserva }) {
  const d = r.dia ? v.dias[r.dia - 1] : undefined;
  return (
    <div className="kippu__cara">
      <p className="kippu__cab"><span>{d ? `JP${num2(d.n)} · ${fechaCorta(d)}` : r.fecha}{r.inicio && r.inicio !== '—' ? ` · ${r.inicio}` : ''}</span></p>
      <p className="kippu__nombre">{titulo(r.que)}</p>
      <p className="kippu__pie">
        {r.estado && <span>{r.estado.toLowerCase()}</span>}
        {r.plataforma && <span>{r.plataforma}</span>}
        {r.importe ? <span>{euros(r.importe)}</span> : null}
      </p>
      <span className="kippu__sello" lang="ja" aria-hidden="true">{SELLO[estadoRes(r)]}</span>
    </div>
  );
}
